import { PeriodFilter, PeriodsPlacementInfo } from '../../lib/types/models/period/period'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getPeriodsPlacementInfo(filter?: PeriodFilter) {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.periods.placementInfo.url, null), { filter }))
    .get<PeriodsPlacementInfo>()
}
